import { render, staticRenderFns } from "./EsException.vue?vue&type=template&id=01fbc38c&scoped=true&"
import script from "./EsException.vue?vue&type=script&lang=js&"
export * from "./EsException.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbc38c",
  null
  
)

export default component.exports